import { Component, OnInit, Input } from '@angular/core';
import { ProjectService } from '../../project.service';
import { Project } from '../../project';
import { saveAs } from 'file-saver';


@Component({
  selector: 'app-download',
  templateUrl: './download.component.html',
  styleUrls: ['../project-form.css']
})


export class DownloadComponent implements OnInit {
  error = false;
  error_type: string;
  on_download = false;
  @Input() project: Project;
  constructor(private projectService: ProjectService) { }

  ngOnInit() {
    this.error = false;
    this.on_download = false;
  }


  exportDXF(): void {
    this.on_download = true;
    this.projectService.getDXF(this.project.id)
      .subscribe(blob => {
        const fileName = this.project.name.replace(/\s/g, '_');
        saveAs(blob, fileName + '.dxf');
        this.error = false;
        this.on_download = false;
      },
      (Error) => {
        this.error = true;
        this.error_type = "diseño de planos";
        this.on_download = false;
      },
    );
  }

  exportDXFLining(): void {
    this.on_download = true;
    this.projectService.getDXFLining(this.project.id)
      .subscribe(blob => {
        const fileName = this.project.name.replace(/\s/g, '_');
        saveAs(blob, fileName + '_paneles.dxf');
        this.error = false;
        this.on_download = false;
      },
      (Error) => {
        this.error = true;
        this.error_type = "diseño de planos";
        this.on_download = false;
      },
    );
  }

  exportEXCEL(cubicationType): void {
    this.on_download = true;
    this.projectService.getEXCEL(this.project.id, cubicationType).
      subscribe(
      (blob) => {
        let filename = 'cubicacion_proyecto_' + cubicationType + '_' + this.project.name + '.xls';
        saveAs(blob, filename);
        this.error = false;
        this.on_download = false;
      },
      (Error) => {
        this.error = true;
        this.error_type = "proceso de cálculo";
        this.on_download = false;
      },
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/project/project-form-components/download/download.component.ts